export default __webpack_public_path__ + "static/media/warning--tunnel--g1.e271c799.png";